import React, { useContext } from "react";
import { LayoutContext } from "../../hooks/layout-context";
import { useTranslation } from "react-i18next";
import ClientForm from "../../components/forms/client-form";

export default function ClientAdd() {
  const { t } = useTranslation();
  const { layout, setLayout } = useContext(LayoutContext);

  React.useEffect(() => {
    layout.sideMenu = "clients";
    layout.breadcrumbs = [
      { label: t("Klienci"), path: "/clients" },
      { path: null, label: t("Dodaj") },
    ];
    setLayout({ ...layout });
  }, []);

  return <ClientForm />;
}
